// @flow
import React from "react";
import AnimationWrapper from "../AnimationWrapper";
import { Overlay, PopupView, Close, SafeImg } from "./StyledComponents";

import safe from "./safe.svg";

import type { Node } from "react";

type Props = {
  onDismiss: () => void,
  children: Node,
  style?: Object
};

export default function Popup({ children, style, onDismiss }: Props) {
  return (
    <Overlay style={style}>
      <AnimationWrapper>
        <PopupView>
          <SafeImg src={safe} alt={safe} />
          <Close onClick={onDismiss} />
          {children}
        </PopupView>
      </AnimationWrapper>
    </Overlay>
  );
}



// WEBPACK FOOTER //
// ./src/components/InsufficientPopup/Popup.js